import { selectColumn } from "components/BaseTableV3/selectColumn";
import TagList from "components/TagList";
import { ScrollColumn } from "components/BaseTableV3/ScrollColumn";
import { TableLink } from "components/BaseTableV3/TableLink";
import DepartmentService from "services/Department";
import { getCampaignStatusName } from "routes/campaign/components/CampaignStatusModal";
import { SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS } from "./ScheduleViewContactsTableV3";

export const getScheduleViewContactsTableColumns = () => {
  return [
    selectColumn,
    {
      header: "Entity",
      id: "Entity",
      accessorKey: "entity_name",
      cell: ({ row }) => (
        <TableLink href={`/entities/${row.original.entity_id}`}>
          {row.getValue("Entity")}
        </TableLink>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      cell: ({ row }) => (
        <TableLink href={`/contacts/${row.original.contact_id}`}>
          {row.getValue("Name")}
        </TableLink>
      ),
    },
    {
      header: "Alternate Names",
      id: "Alternate Names",
      accessorKey: "alternate_names",
      enableSorting: false,
      cell: ({ row }) => (
        <ScrollColumn>
          {(row.getValue("Alternate Names") || []).map(({ id, name }) => (
            <li key={id}>{name}</li>
          ))}
        </ScrollColumn>
      ),
    },
    {
      header: "Email",
      id: "Email",
      accessorKey: "email",
    },
    {
      header: "Department",
      id: "Department",
      accessorKey: "department_name",
      enableSorting: false,
    },
    {
      header: "Alternate Emails",
      id: "Alternate Emails",
      accessorKey: "email_addresses",
      enableSorting: false,
      cell: ({ row }) => (
        <ScrollColumn>
          {row
            .getValue("Alternate Emails")
            .filter(email => !email.is_primary)
            .map(({ id, email }) => (
              <li key={id}>{email}</li>
            ))}
        </ScrollColumn>
      ),
    },
    {
      header: "Contact Tags",
      id: "Contact Tags",
      accessorKey: "contact_tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.getValue("Contact Tags")}
          modelType={SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS.className}
          modelId={row.original.id}
          readOnly
          tableCell
        />
      ),
    },
    {
      header: "Entity Tags",
      id: "Entity Tags",
      accessorKey: "entity_tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.getValue("Entity Tags")}
          modelType={SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS.className}
          modelId={row.original.id}
          readOnly
          tableCell
        />
      ),
    },
    {
      header: "Campaign Status",
      id: "Campaign Status",
      accessorKey: "campaign_status",
      size: 150,
      cell: ({ row }) => getCampaignStatusName(row.getValue("Campaign Status")),
    },
    {
      header: "Last Call Disposition",
      id: "Last Call Disposition",
      accessorKey: "last_call_disposition",
    },
  ];
};

export const getScheduleViewContactsTableFilters = ({ tags }) => {
  return [
    {
      key: "search:contact_name",
      title: "Contact Name",
      type: "input",
    },
    {
      key: "search:contact_email",
      title: "Contact Email",
      type: "input",
    },
    {
      key: "search:contact_alternate_email",
      title: "Contact Alternate Email",
      type: "input",
    },
    {
      key: "search:entity_name",
      title: "Entity Name",
      type: "input",
    },
    {
      key: "department_id",
      title: "Department Name",
      type: "ruvixxSelect",
      queryFn: DepartmentService.getForFilters,
    },
    {
      key: "tag_id",
      title: "Tag",
      type: "tag",
      data: tags,
    },
  ];
};
